import { render, staticRenderFns } from "./ElementImageContainer.vue?vue&type=template&id=4381d313&scoped=true&"
import script from "./ElementImageContainer.vue?vue&type=script&lang=js&"
export * from "./ElementImageContainer.vue?vue&type=script&lang=js&"
import style0 from "./ElementImageContainer.vue?vue&type=style&index=0&id=4381d313&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4381d313",
  null
  
)

export default component.exports